/**
 * voteSetting接口
 */
import axios from '../utils/https' // 导入http中创建的axios实例

const voteSetting = {
  getVoteSetting (params) {
    return axios.get('/api/voteSetting/GetVoteSetting', { params })
  },
  editVoteSetting (params) {
    return axios.post('/api/voteSetting/EditVoteSetting', params)
  },
  editVoteSettingAndUpload (params) {
    return axios.post('/api/voteSetting/EditVoteSettingAndUpload', params)
  }
}

export default voteSetting
